export default __webpack_public_path__ + "static/media/e_wdt_c_0.ef56ffd5.mp3";